export enum Role {
  User = 'USER'
}
